import React from 'react'

const characterCountMessage = (charCount, maxChars, isReminder = false) => {
  const textCount = Math.ceil(charCount / 160)
  const pluralTexts = textCount !== 1 ? 's' : ''
  const pluralChars = charCount !== 1 ? 's' : ''
  const atMax = charCount === maxChars
  const exceedsMax = charCount > maxChars
  const isBrokenUp = charCount > 160
  const messageType = isReminder ? 'reminder' : 'message'

  if (atMax) {
    return (
      <span>
        {`You are at the character limit (${maxChars}) for this ${messageType}.`}
      </span>
    )
  } else if (exceedsMax) {
    return (
      <span>
        {`You have exceeded the character limit (${charCount}/${maxChars}) for this ${messageType}.`}
      </span>
    )
  }
  return (
    <span>
      {`This ${messageType} contains `}
      <strong>{charCount}</strong>
      {` character${pluralChars}`}
      {isBrokenUp ? ' and may be split and sent as ' : '.'}
      {isBrokenUp && <strong>{textCount}</strong>}
      {isBrokenUp && ` individual text${pluralTexts}.`}
    </span>
  )
}

export default characterCountMessage



// WEBPACK FOOTER //
// ./src/services/character-count.js